import React from 'react';
import { NextPage } from 'next';
import SidebarContainer from '../../../components/@container/sidebar-container';
import VidaSidebar from '../../../components/@vida/vida-sidebar';
import Layout from '../../../components/layout';
import VidaComputerRequirements from '../../../components/@vida/vida-computer-requirements';

const VidaComputerRequirementsPage: NextPage = () => (
  <Layout title="VIDA Computer Requirements" omit={true}>
    <SidebarContainer
      sidebar={<VidaSidebar />}
      content={<VidaComputerRequirements />}
    />
  </Layout>
);

export default VidaComputerRequirementsPage;
